import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { QuarantinedDocument } from '../constants/quarantined-document.constants';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class QuarantinedDocumentsPersistenceService {

  releaseDocuments$ = new BehaviorSubject<boolean>(false);
  
  constructor(private confirmationService: ConfirmationService) { }

    openConfirmationDialogForRelease = () => {
      this.confirmationService.confirm({
        message: QuarantinedDocument.QuarantineDocument_Release_Confirmation_Text,
        header: QuarantinedDocument.QuarantineDocument_Confirmation_Header,
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.releaseDocuments$.next(true);
        },
      });
    }

}
